module.exports = __webpack_public_path__ + "img/hero-1.1a11f3f9.jpg";